import { createNaturalArithmeticTask, randInt, simpleAdditionExplanation } from "./sharedNaturalArithmetic";

function pickData() {
  for (let i = 0; i < 500; i += 1) {
    const a = randInt(12, 76);
    const b = Math.random() < 0.45 ? randInt(2, 9) : randInt(11, 42);
    if ((a % 10) + (b % 10) < 10 && a + b < 100) return { a, b, op: "+", result: a + b };
  }
  return { a: 32, b: 23, op: "+", result: 55 };
}

const mod = createNaturalArithmeticTask({
  type: "NaturalAddTwoDigitNoCarryTask",
  pickData,
  explain: simpleAdditionExplanation,
});

export const generateTask = mod.generateTask;
export const renderTask = mod.renderTask;
export const renderInput = mod.renderInput;
export const checkAnswer = mod.checkAnswer;
export const renderAnswer = mod.renderAnswer;
export const renderUserAnswer = mod.renderUserAnswer;
export const renderExplanation = mod.renderExplanation;
